import { FunctionComponent, useState } from "react"
import { useNavigate } from "react-router-dom";
import AutoMap from "src/components/cbc/AutoMAP";
import { Button, PageContainer, PageTitle } from "src/components/generic";
import { TextInput } from "src/components/inputs";
import { useAuth } from "src/context/AuthContext";

interface IInitialMAPProps {
    recall?: boolean;
}

const InitialMAP: FunctionComponent<IInitialMAPProps> = ({ recall }) => {
    const [ssn, setSSN] = useState<string | null>(null);
    const [MAPView, setMAPView] = useState<boolean>(false);
    const navigate = useNavigate();
    const storedUser = localStorage.getItem("user");
    const authContext = useAuth();

    const user = recall ? authContext?.user : storedUser ? JSON.parse(storedUser) : null;

    const pullMAP = () => {
        if(ssn && (ssn?.length === 9) && user) setMAPView(true);
    }

    if(!user) return <div>No User Found</div>

    return (
        <PageContainer>
            <PageTitle title="CV MAP" />
            <p>ClientVitals does not store, retrieve, own, or sell social security numbers.</p>
            {
                (MAPView && typeof ssn === "string") ? (
                    <div>
                        <AutoMap
                            client={user}
                            ssn={ssn}
                        />

                        <Button text="Go To Login" onClick={() => navigate('/auth/login')} />
                    </div>
                ) : (
                    <div>
                        <TextInput 
                            id='ssn'
                            placeholder="Confim SSN"
                            onChange={(value: string) => setSSN(value.replaceAll('-',''))}
                            password
                        />

                        <Button text="Get Credit Overview" onClick={pullMAP} />
                        {/* <Button text="Go To Login" onClick={() => navigate('/auth/login')} /> */}
                    </div>
                ) 
            }
        </PageContainer>
    )
}

export default InitialMAP;
